import React from 'react';
import { clearLocalStorage } from '../../../util/local-storage-util';
import { translate, getTranslatedImage } from '../../../translations/translator';
import { remCalc } from '../../../util/style-util';
import { gray4, lightGreen, white } from '../../../styles/style-constants';
import WebLink from '../WebLink';
import { makeStyles } from '@mui/styles';
const translateErrors = key => translate('errors', key);

const NotFoundRoute = () => {
  const classes = useStyles();
  return (
    <div className={classes.presenterWrapper}>
      <div className={classes.leftContainer}>
        <img
          className={classes.leftImg}
          src={getTranslatedImage('404-sorry-kid.png')}
          alt="404 Error"
        />
      </div>
      <div className={classes.rightContainer}>
        <p>{translateErrors('404Title')}</p>
        <p className={classes.title}>{translateErrors('notFound')}</p>
        <p>{translateErrors('cantFind')}</p>
        <WebLink to={'/home'} className={classes.goHome} onClick={clearLocalStorage}>
          {translateErrors('goHome')}
        </WebLink>
      </div>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  presenterWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    backgroundColor: white,
    fontWeight: 300,
    fontSize: remCalc(26),
    color: gray4
  },
  leftContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '50%',
    padding: remCalc(50)
  },
  rightContainer: {
    width: '50%'
  },
  title: {
    fontSize: remCalc(56),
    fontWeight: 500
  },
  goHome: {
    color: white,
    backgroundColor: lightGreen,
    borderRadius: '5px',
    padding: `${remCalc(5)} ${remCalc(20)}`,
    marginTop: remCalc(10),
    fontSize: remCalc(14),
    textDecoration: 'none'
  },
  leftImg: {
    height: remCalc(550)
  }
}));

export default NotFoundRoute;
